<!--
 * @Author: yukiice
 * @Date: 2021-06-05 15:12:39
 * @LastEditTime: 2021-08-11 16:23:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xiaoxi_xiaohe/h5/src/views/Detail/index.vue
-->
<template>
  <div class="main">
    <div class="swipers" v-if="!special">
      <van-swipe
        class="my-swipe"
        :autoplay="3000"
        indicator-color="white"
        v-if="detailData.imgs.length !== 0"
      >
        <van-swipe-item v-for="item in detailData.imgs" :key="item.id">
          <van-image :src="$store.state.baseUrl + item" alt="暂无" />
        </van-swipe-item>
      </van-swipe>
      <div v-else class="swiper_else">暂无图片</div>
    </div>
    <div class="swiperss" v-if="special">
      <img :src="$store.state.baseUrl + detailData.thumbImg" alt="" />
    </div>

    <div class="bodys">
      <!--  -->
      <div class="about" v-if="!special">
        <div class="ones">
          <div class="lefts">
            <div class="icons"></div>
            <div class="middles">
              {{ detailData.address ? detailData.address : "暂无" }}
            </div>
          </div>
          <div class="rights" @click="daohang">
            <div class="r_l"></div>
            <div class="r_r">{{$store.state.languageType === 1?'导航':'guide'}}</div>
          </div>
        </div>
        <!--        -->
        <div
          class="twos"
          v-if="detailData.poiTypeId === 2 && detailData.mobile.length !== 0"
        >
          <div class="l_l">
            <div class="l_1"></div>
            <div class="l_2">
              {{ detailData.mobile }}
            </div>
          </div>
          <div class="r_r" @click="toTel">
            <div class="r_1"></div>
            <div class="r_2">拨打</div>
          </div>
        </div>
      </div>
      <div
        class="audios"
        v-if="!special && detailData.audio.length !== 0"
      >
        <AudioPlay
          :audioSrc="$store.state.baseUrl + detailData.audio"
        ></AudioPlay>
      </div>
      <div :class="['lines']">
        <div class="leftss">
          {{ detailData.name }}
        </div>
        <!-- <div
          v-if="detailData.poiTypeId === 1"
          class="rightss"
          @click="jumpToOther"
        >
          <div class="l_l">进入景点</div>
          <div class="r_r"></div>
        </div> -->
      </div>
      <!--  -->
      <div
        class="detail"
        v-html="detailData.pointInfo"
        v-if="!special && detailData.pointInfo.length !== 0"
      ></div>
      <div
        class="detail"
        v-html="detailData.details"
        v-if="special"
      ></div>
    </div>
    <div
      class="back_icon"
      id="back_icon"
      @click="backToHome"
      ref="obtain"
    ></div>
  </div>
</template>

<script>
import {
  GetPointDetail,
  GetLineDetail,
  GetSpecialInfo,
} from "@/api/home.api.js";
import AudioPlay from "@/components/AudioPlayer.vue";
export default {
  data() {
    return {
      detailData: {},
      lineShow: false,
      cards: {},
      lunboShow: true,
      cnShow: true,
      detailId: "",
      showOne: false,
      showTwo: false,
      showThree: false,
      offsetTops: null,
      bool: true,
      languageType: null,
      lineshow: null,
      special: null,
    };
  },
  created() {
    this.detailId = this.$route.query.id;
    console.log(sessionStorage.getItem('LineShow'));
    this.lineShow = JSON.parse(sessionStorage.getItem('LineShow'));
    this.special = JSON.parse(sessionStorage.getItem('special'));;
    this.languageType = JSON.parse(
      JSON.stringify(this.$store.state.languageType)
    );
    this.init();
  },
  mounted() {
    
  },
  components: { AudioPlay },
  methods: {
    async init() {
      console.log(this.special);
      if (this.special) {
        console.log(1);
        let { data: res } = await GetSpecialInfo({
          id: this.detailId,
          language: this.languageType,
        });
        this.detailData = res.data;
      } else if (this.lineShow) {
        let { data: res } = await GetPointDetail({
          id: this.detailId,
          languageType: this.languageType,
        });
        this.detailData = res.data.pointWebBO
      } else {
        console.log(3);
        let { data: res } = await GetPointDetail({
          id: this.detailId,
          languageType: this.languageType,
        });
        this.detailData = res.data.pointWebBO;
      }

      console.log(this.detailData, "这是data");
    },
    backToHome() {
      this.$router.go(-1);
    },
    daohang() {
      // 在浏览器就用高德地图
      // 判断运行环境
      // 在浏览器就用高德地图
      console.log("在浏览器");
      let lng1 = sessionStorage.getItem("lng");
      let lat1 = sessionStorage.getItem("lat");
      let url =
        "http://uri.amap.com/navigation//uri.amap.com/navigation?from=" +
        lng1 +
        "," +
        lat1 +
        ",我的位置&to=" +
        this.detailData.longitude +
        "," +
        this.detailData.latitude +
        "," +
        this.detailData.name +
        "&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0";
      window.location.href = url;
    },
    jumpToOther() {
      window.location.href = this.detailData.viewUrl;
    },
    toTel() {
      window.location.href = "tel://" + this.detailData.mobile;
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  overflow: auto;
  overflow-x: hidden;
  min-height: 100vh;
  width: 100vw;
  background: #fafafa;
}
.swiper_else {
  text-align: center;
  line-height: 20vh;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 25vh;
  text-align: center;
  background-color: #39a9ed;
}
.swiperss {
  height: 25vh;
  img {
    display: block;
    width: 100% !important;
    height: 100% !important;
  }
}
.bodys {
  position: absolute;
  top: 25vh;
  left: 0;
  width: 100vw;
  overflow: hidden;

  border-top: 1px solid #ccc;
  background: #fafafa;
}

.about {
  background-color: #ffffff;

  .ones {
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .lefts {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 0.5rem;

      .icons {
        background-image: url("../../static/icon_address@2x.png");
        background-size: 100% 100%;
        height: 1rem;
        width: 1rem;
      }

      .middles {
        width: 13rem;
        margin-left: 0.5rem;
        color: #444444;
        font-size: 14px;
        text-align: left;
        font-family: PingFangSC-regular;
      }
    }

    .rights {
      margin-right: 0.5rem;
      opacity: 1;
      background: #4f8bff;
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.25rem 0.6rem;

      .r_l {
        background-image: url("../../static/icon_nav@2x.png");
        background-size: 100% 100%;
        width: 1rem;
        height: 1rem;
      }

      .r_r {
        font-size: 0.8rem;
        font-weight: 500;
        text-align: CENTER;
        color: #ffffff;
        letter-spacing: 0;
      }
    }
  }

  //  第二种
  .twos {
    display: flex;
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .l_l {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 0.5rem;

      .l_1 {
        background-image: url("../../static/icon_phone@2x.png");
        background-size: 100% 100%;
        height: 1rem;
        width: 1rem;
      }

      .l_2 {
        width: 13rem;
        margin-left: 0.5rem;
        color: #444444;
        font-size: 14px;
        text-align: left;
      }
    }

    .r_r {
      margin-right: 0.5rem;
      opacity: 1;
      background: #ffb156;
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.25rem 0.6rem;

      .r_1 {
        background-image: url("../../static/icon_call@2x.png");
        background-size: 100% 100%;
        width: 1rem;
        height: 1rem;
      }

      .r_2 {
        font-size: 0.8rem;
        font-weight: 500;
        text-align: CENTER;
        color: #ffffff;
        letter-spacing: 0;
      }
    }
  }
}
.no_detail {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 5rem;
  .no_tops {
    background-image: url("../../static/no_data@2x.png");
    background-size: 100% 100%;
    width: 11rem;
    height: 8rem;
  }
  .no_bottoms {
    font-size: 1rem;
    font-weight: 400;
    text-align: CENTER;
    color: #98a2af;
    letter-spacing: 0;
  }
}
.detail {
  text-indent: 2em;
  line-height: 28px;
  padding: 0rem 1rem;

  ::v-deep table {
    width: 100% !important;
  }

  ::v-deep p {
    text-indent: 2em !important;
    font-size: 0.9rem;
    font-weight: 400;
    text-align: LEFT;
    color: #666666;
    line-height: 1.7rem;
    letter-spacing: 0px;
    display: flex;
  }
  ::v-deep img {
    width: 90vw;
    height: auto;
  }
}
.audios {
  margin-top: 2rem;
  height: 72px;
  width: 95vw;
  margin-left: 2vw;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 30px;
  box-shadow: -1px 2px 8px 0px rgba(204, 204, 204, 0.6);
}
.lines {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 18px;
  line-height: 36px;
  font-weight: bold;
  color: #212121;
}

.liness {
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  display: flex;
  font-size: 18px;
  font-weight: bold;
  color: #212121;

  .leftss {
    margin-left: 2rem;
  }

  .rightss {
    margin-right: 0.5rem;
    opacity: 1;
    border: 1px solid #dfdfdf;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem 0.6rem;

    .l_l {
      font-size: 0.6rem;
      font-weight: 500;
      text-align: CENTER;
      color: #666666;
      letter-spacing: 0px;
    }

    .r_r {
      background-image: url("../../static/icon_w_to@2x.png");
      background-size: 100% 100%;
      width: 1rem;
      height: 1rem;
      margin-right: -0.4rem;
    }
  }
}

.iconss {
  color: #fe921d;
}

.back_icon {
  position: fixed;
  right: 0.7rem;
  bottom: 4rem;
  background-image: url("../../static/Group 313@2x.png");
  background-size: 100% 100%;
  width: 4rem;
  height: 4rem;
}
</style>